eliminarServicio = function(e){
    var data = e.dataset;
    $("#form_eliminar_servicio")[0].reset();
    $("#eliminar_servicio_id").val(data.id);
    $("#eliminar_servicio_nombre").html(`¿Deseas eliminar el servicio <strong>${data.nombre}</strong>?`);
}